import CreatePage from './CreatePage';
import ListPage from './ListPage';

export default {
  CreatePage,
  ListPage
};
